// src/components/Loading.js

function Loading() {
 return (
  <div className="c-loading">
   <div className="c-loading__spinner"></div>
   <p className="c-loading__message">読み込み中</p>
  </div>
 );
}

export default Loading;
